import { IconProfiles } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentProfiles';
const links = [
  {
    title: 'End-users',
    href: '/profiles/existing',
    activePaths: ['/profiles/edit/:profileID'],
  },
  { title: 'Add new end user', href: '/profiles/new' },
  { title: 'Documents', href: '/profiles/documents' },
];
const profilesSubNav = () =>
  subNav({
    id: navId,
    title: 'End users',
    href: '/profiles',
    icon: IconProfiles,
    links,
  });
export default profilesSubNav;
